// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleFilledSvg from "@ant-design/icons-svg/es/asn/RightCircleFilled";
import AntdIcon from '../components/AntdIcon';

var RightCircleFilled = function RightCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleFilledSvg
  }));
};

RightCircleFilled.displayName = 'RightCircleFilled';
export default React.forwardRef(RightCircleFilled);